import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#0A0A0A] text-white mt-32"
    >
      <div className="px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-baseline gap-2 mb-4">
            <span className="font-display text-2xl font-semibold tracking-tight">
              Stageletics
            </span>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed max-w-sm">
            Premium stage gear for churches, venues, and worship spaces.
            Designed in the USA. Built to bring aura to your stage.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Shop</p>
          <ul className="space-y-3">
            <li>
              <Link to="/product" data-testid="footer-link-product" className="text-sm text-zinc-400 hover:text-white transition-colors">Aura Sleeve</Link>
            </li>
            <li>
              <Link to="/cart" data-testid="footer-link-cart" className="text-sm text-zinc-400 hover:text-white transition-colors">Cart</Link>
            </li>
            <li>
              <Link to="/wholesale" data-testid="footer-link-wholesale" className="text-sm text-zinc-400 hover:text-white transition-colors">Bulk &amp; Wholesale</Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Support</p>
          <ul className="space-y-3">
            <li><Link to="/faq" data-testid="footer-link-faq" className="text-sm text-zinc-400 hover:text-white transition-colors">FAQ</Link></li>
            <li><Link to="/returns" data-testid="footer-link-returns" className="text-sm text-zinc-400 hover:text-white transition-colors">Returns</Link></li>
            <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-sm text-zinc-400 hover:text-white transition-colors">Privacy</Link></li>
            <li><Link to="/terms" data-testid="footer-link-terms" className="text-sm text-zinc-400 hover:text-white transition-colors">Terms</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row justify-between items-center gap-3">
        <p className="text-xs text-zinc-500">© {new Date().getFullYear()} Stageletics. All rights reserved.</p>
        <p className="text-xs text-[#E8A851] uppercase tracking-[0.2em]">Engineered for Showtime.</p>
      </div>
    </footer>
  );
}
